import axios from 'axios';
import { environment } from 'src/app/constants';

type PostData = { [key: string]: unknown } | [];

export async function getSearchResultFromQueryParameter<T>(
  queryType: string,
  searchParameter: string,
  postData: PostData
): Promise<T[]> {
  const url = `${environment.apiUrl}/${queryType}/query?searchParam=${searchParameter}`;
  const payload = {
    ...postData,
  };
  const accessTokenVal = localStorage.getItem('id_token') ?? '';
  try {
    const response = await axios.post<T[]>(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessTokenVal}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error during the Axios request:', error);
    throw error;
  }
}

export async function getFinalResultCost<T>(
  queryType: string,
  searchParameter: string,
  postData: PostData
): Promise<T[]> {
  const url = `${environment.apiUrl}/${queryType}/query/${searchParameter}`;

  const payload = {
    ...postData,
    engine: null,
  };
  const accessTokenVal = localStorage.getItem('id_token') ?? '';
  try {
    const response = await axios.post<T[]>(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessTokenVal}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error during the Axios request:', error);
    throw error;
  }
}

export async function getVehicleStatusModuleHistory<T>(
  queryType: string,
  searchParameter: string,
  postData: PostData = []
): Promise<T[]> {
  const url = `${environment.apiUrl}/vehicle/${queryType}/${searchParameter}`;
  const accessTokenVal = localStorage.getItem('id_token') ?? '';
  try {
    const response = await axios.get<T[]>(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessTokenVal}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error during the Axios request:', error);
    throw error;
  }
}

export async function getSessionModuleFiles<T>(searchedVin: string): Promise<T[]> {
  const url = `${environment.apiUrl}/vehicle/session/${searchedVin}?&queryParameter=sourceFile`;
  const accessTokenVal = localStorage.getItem('id_token') ?? '';
  try {
    const response = await axios.get<T[]>(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessTokenVal}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error during the Axios request:', error);
    throw error;
  }
}

export async function exportVehicleSessionHistory<T>(
  searchedVin: string,
  fileType: string,
  postData: PostData[]
): Promise<T[]> {
  let url = '';
  if (fileType === 'vehicle') {
    url = `${environment.apiUrl}/vehicle/export/${searchedVin}`;
  } else if (fileType === 'session') {
    url = `${environment.apiUrl}/vehicle/sessionfiles/export/${searchedVin}`;
  }
  const payload = postData;
  const accessTokenVal = localStorage.getItem('id_token') ?? '';
  try {
    const response = await axios.post<T[]>(url, fileType === 'vehicle' ? '' : payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessTokenVal}`,
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error during the Axios request:', error);
    throw error;
  }
}
